var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.033 64.192l-27.305 26.66-27.302-26.66 27.302-26.651zm0 0",
    fill: "#932279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.72 58.736L37.824 31.91 64.72 5.084 91.61 31.91zm0 0",
    fill: "#efa724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.675 96.563l-27.307 26.661-27.3-26.661 27.302-26.65zm0 0",
    fill: "#9ccd2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.362 91.108L70.466 64.277l26.895-26.821 26.895 26.821zm0 0",
    fill: "#262577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.066 69.484h36.461v36.401H70.066zm0 0",
    fill: "#efa724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.216 22.454h36.577v36.231H70.216zm0 0",
    fill: "#932279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1 69.484h38.084v37.753H21.1zm0 0",
    fill: "#262577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1 20.928h38.084v37.538H21.1zm0 0",
    fill: "#9ccd2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.722.464L48.268 17.227H19.739v28.395L2.483 62.837l17.256 17.229v28.149h27.697l16.93 16.901 16.935-16.901h27.983V80.148l16.89-17.229-16.66-16.973V17.454H81.392zm-.005 3.9l12.841 13.089h-8.71v33.645l-4.13 4.206-4.175-4.257v-33.82h-8.445zm-42.26 15.633h23.107l-9.661 9.841 21.92 22.356v3.418h-4.105L31.723 33.653 22.458 42.9zm26.937 0h8.43v28.277L39.743 29.836zm22.177.215h8.695l9.431 9.626L71.569 48.32zm12.529 0h22.697v22.951l-9.436-9.62-21.856 22.291h-3.934v-3.599l21.961-22.398zm13.261 17.245l9.436 9.615v8.761H79.339zm-65.633.067l18.117 18.089H22.457V46.78zM19.74 49.487v8.878h32.864l4.49 4.472-4.03 4.027H19.739v9.328L6.364 62.837zm89.776.358l12.825 13.074-13.057 13.315V66.86H76.246l-3.86-3.94 4.249-4.329h32.878zm-48.974 5.117l4.175 4.247 4.13-4.201v3.581h3.955l-4.249 4.329 3.86 3.94h-3.7v4.222l-4.346-4.339-3.819 3.817v-3.694H56.94l4.03-4.027-.966-.956-3.524-3.516h4.065zm-38.08 14.656H50.3L31.728 88.161l-9.265-9.256zm31.712 0h3.65v3.659L35.127 95.928l9.546 9.527H22.462V82.777l9.261 9.247zm17.256 0h3.689l22.241 22.68.961-.967 8.24-8.413v22.546H84.06l9.551-9.533-.966-.972L71.43 73.795zm7.519 0h27.613v9.39l-9.201 9.379zm-14.577.998l4.34 4.335v33.267h8.716l-13.055 13.028-13.055-13.028h9.231V74.431zm-6.547 6.534v28.307h-9.27l-9.546-9.527zm13.606.512L89.737 95.93l-9.551 9.533H71.43zm0 0",
    fill: "#fff"
  }));
};